export enum UserStatusType {
  Active = "Active",
  Pending = "Pending",
  Inactive = "Inactive",
}
